import { cn } from "@/lib/utils";

interface MappingProgressBarProps {
  done: number;
  total: number;
  className?: string;
}

export function MappingProgressBar({ done, total, className }: MappingProgressBarProps) {
  const pct = total > 0 ? Math.round((done / total) * 100) : 0;
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <div className="relative h-1.5 w-16 overflow-hidden rounded-full bg-muted">
        <div
          className="absolute inset-y-0 left-0 bg-green-500 transition-all"
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className="text-xs font-medium tabular-nums">
        {done}/{total} done
      </span>
    </div>
  );
}
